import { Card, Row, Col, DatePicker, Button, Space } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';

const { RangePicker } = DatePicker;

const data = [
  {
    id: 1,
    title: 'Đề số 1',
  },
  {
    id: 2,
    title: 'Đề số 2',
  },
  {
    id: 3,
    title: 'Đề số 3',
  },
  {
    id: 4,
    title: 'Đề số 4',
  },
  {
    id: 5,
    title: 'Đề số 5',
  },
];

function CreateExerciseByUnit() {
  function onChange(value, dateString) {
    console.log('Selected Time: ', value);
    console.log('Formatted Selected Time: ', dateString);
  }

  function onOk(value) {
    console.log('onOk: ', value);
  }

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      {data.map(item => (
        <Card key={item.id}>
          <Row>
            <Col span={8}>{item.title}</Col>
            <Col span={8}>
              Hạn nộp bài&nbsp;
              <RangePicker
                showTime={{ format: 'HH:mm' }}
                format="DD-MM-YYYY HH:mm"
                onChange={(value, dateString) => onChange(value, dateString)}
                onOk={(value) => onOk(value)}
              />
            </Col>
            <Col span={8}>
              <Button
                onClick={() => {

                }}
                key='Assignment'
                type='primary'
                icon={<FileTextOutlined />}
              >
                Giao bài
              </Button>
            </Col>
          </Row>
        </Card>
      ))}
    </Space>
  );
}

export default CreateExerciseByUnit;
